import { render, staticRenderFns } from "./ZavaHeader.vue?vue&type=template&id=06e2a7b4"
import script from "./ZavaHeader.vue?vue&type=script&lang=js"
export * from "./ZavaHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports